import { ApiCustomer } from '@vend/types'
import { getFeatureFromCache } from '../../util/feature-cache'
import { FEATURE_ON_ACCOUNT_PAYMENT_TYPE } from '../../constants/wr-features'
import { isValidCustomer, isOnAccountLimitReached } from '../sale'
import {
  isOnAccountLimitDisabled,
  isOnAccountLimitUnlimited,
} from '../customer'
import { ReduxCurrentSale } from '../../state/slices/currentSale/currentSaleSlice'

type ShouldDisableOnAccountPaymentParams = {
  customer: ApiCustomer | null | undefined
  sale: Pick<
    ReduxCurrentSale,
    'customerBalances' | 'payAccountBalance' | 'payments' | 'finals'
  >
}

/**
 * Evaluates the current sale and determines if the On Account payment option should be disabled.
 *
 * @method shouldDisableOnAccountPayment
 *
 * @param {ShouldDisableOnAccountPaymentParams} params
 *
 * @return {Boolean} True if the On Account payment option should be disabled, false otherwise.
 */
export const shouldDisableOnAccountPayment = ({
  customer,
  sale,
}: ShouldDisableOnAccountPaymentParams): boolean => {
  if (!getFeatureFromCache(FEATURE_ON_ACCOUNT_PAYMENT_TYPE)) {
    return true
  }

  if (!isValidCustomer(customer)) {
    return true
  }

  if (isOnAccountLimitDisabled(customer)) {
    return true
  }

  if (!isOnAccountLimitUnlimited(customer) && isOnAccountLimitReached(sale)) {
    return true
  }

  return false
}
